import { TRootState } from "../@types";

export const selectModalTax = ( state: TRootState ) => state.tax.taxModalIsOpen

export const selectTaxForUpdate = ( state: TRootState ) => state.tax.taxForUpdate

export const selectTaxRefreshTable = ( state: TRootState ) => state.tax.refreshTableTax